<template>
  <div class="products-by-id">
    <h6 class="mt-4 mb-1">Товары в стратегии:</h6>
    <div class="demo-inline-spacing mb-2">
      <button class="btn btn-outline-primary" @click="openProductsSelect">Добавить товары в стратегию</button>
      <button class="btn btn-outline-danger" :disabled="selected_for_delete_ids.length === 0" @click="deleteSelectedProducts">Удалить выбранные товары
        ({{ selected_for_delete_ids.length }})
      </button>
    </div>

    <ProductsListSimple ref="ProductsList" by="productIds" :product_ids="local_product_ids" :with_checkbox="true"
                      @selection-changed="updateSelectedForDeleteProducts"
                      :columns="getColumns()">
      <template #column-value="{ product }" v-if="value_set_type === 'individual'">
        <input
            type="number"
            class="form-control"
            :value="local_value_individual[product.id] || ''"
            @input="updateProductValue(product.id, $event.target.value)"
        >
      </template>
    </ProductsListSimple>

    <OffCanvas title="Подбор товаров" ref="productsSelect" :width="1000">
      <ProductsSelect @products-selected="addSelectedProducts" />
    </Offcanvas>
  </div>
</template>

<script>
import ProductsListSimple from "@/components/strategy/ProductsListSimple.vue";
import OffCanvas from "@/components/page/OffCanvas.vue";
import ProductsSelect from "@/components/strategy/ProductsSelect.vue";

export default {
  name: 'ProductsById',
  components: {ProductsListSimple, OffCanvas, ProductsSelect},
  data() {
    return {
      selected_for_delete_ids: [],
      local_product_ids: [...this.product_ids],
      local_value_individual: { ...this.value_individual }
    }
  },
  props: {
    product_ids: {
      type: Array,
      default: () => []
    },
    value_individual: {
      type: Object,
      default: () => ({})
    },
    value_set_type: {
      type: String,
      default: 'for_all'
    },
    value_type: {
      type: String,
      default: 'profit'
    },
  },
  methods: {
    openProductsSelect() {
      this.$refs.productsSelect.open()
    },
    addSelectedProducts(selected_product_ids) {
      this.local_product_ids = [...new Set([...this.local_product_ids, ...selected_product_ids])]
      this.$emit('update:product_ids', this.local_product_ids)
      this.$refs.productsSelect.close()
    },
    async updateProducts() {
      await this.$refs.ProductsList.refreshProducts()
    },
    updateSelectedForDeleteProducts(selectedIds) {
      this.selected_for_delete_ids = selectedIds
    },
    deleteSelectedProducts() {
      this.local_product_ids = this.local_product_ids.filter(id => !this.selected_for_delete_ids.includes(id))
      // Удаляем значения для удаленных товаров
      if(this.value_set_type === 'individual'){ 
        this.selected_for_delete_ids.forEach(id => {
          delete this.local_value_individual[id]
        }) 
      }
      this.$emit('update:product_ids', this.local_product_ids)
      this.$emit('update:value_individual', this.local_value_individual)
      this.selected_for_delete_ids = []
      this.$refs.ProductsList.reset()
      this.$refs.ProductsList.refreshProducts()
    },
    getColumns() {
      if (this.value_set_type === 'for_all'){
        return []
      }else{
        let label = 'Цена'
        if(this.value_type === 'profit_amount'){
          label = 'Прибыль'
        }
        if(this.value_type === 'profit_percent'){
          label = 'Процент прибыли (от цены)'
        }
        if(this.value_type === 'profit_percent_cost'){
          label = 'Процент прибыли (от себестоимости)'
        }
        return [
          {key: 'value', label: label},
        ]
      }
    },
    updateProductValue(id, value) {
      this.local_value_individual[id] = value
      this.$emit('update:value_individual', this.local_value_individual)
    }
  },
  emits: ['update:product_ids', 'update:value_individual'],
  watch: {
    product_ids: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.local_product_ids)) {
          this.local_product_ids = [...newVal]
        }
      },
      deep: true
    },
    value_individual: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.local_value_individual)) {
          this.local_value_individual = { ...newVal }
        }
      },
      deep: true
    },
    value_set_type: {
      handler(newVal) {
        if (newVal === 'for_all') {
          this.local_value_individual = null
          this.$emit('update:value_individual', null)
        }
        if(newVal === 'individual' && this.local_value_individual === null){
          this.local_value_individual = {}
          this.$emit('update:value_individual', {})
        }
      },
      immediate: true
    }
  },
}
</script>